import React from 'react'
import { Player, Controls } from '@lottiefiles/react-lottie-player';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

export default function LottiePlayer({file,style=null,dot=false}) {
  return (
    <div>
      {dot ?
        <DotLottieReact
          src={file}
          style={style}
          loop
          autoplay
        />
        :
        <Player
          autoplay
          loop
          style={style}
          src={file}
        >
          <Controls visible={false} buttons={['play', 'repeat', 'frame', 'debug']} />
        </Player>
      }
    </div>
  )
}
